module.exports = __webpack_public_path__ + "img/menu-single-site.275c5416.svg";